import logger from '@eventbrite/client-logger';
import { logEvent } from '@eventbrite/statsig';
import React from 'react';

const sluglify = (original?: string) => {
    if (original) {
        const slug = original
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '_')
            .replace(/[^\w-]+/g, '')
            .replace(/\-+/g, '_');

        return slug;
    }

    return original || ''; // Return empty string instead of undefined
};

export const trackClick = (
    url: string,
    callToAction: string,
    ctaElement?: string,
) => {
    return (_event: React.MouseEvent<HTMLElement>) => {
        const metricName = 'CreatorMLP - Click - CTA';
        const dimensions = {
            ctaText: sluglify(callToAction),
            url: url,
            source: sluglify(ctaElement) || 'unknown_source',
        };

        try {
            logEvent(metricName, 1, dimensions);
        } catch (error) {
            logger.warn('Wagtail - Error logging CTA to Statsig.');
        }
    };
};
